module.exports = __webpack_public_path__ + "static/media/IMG_7162.99d60162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_7162.jpg
// module id = 161
// module chunks = 0